import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

export default class FieldRowWithTextInput extends Component {
  static propTypes = { label: PropTypes.string };
  state = { value: '' }
  componentWillReceiveProps(nextProps) {
    const { value } = nextProps
    this.setState(state => ({...state, value }))
  }
  render() {
    const { label, className, type } = this.props;
    return (
      <Wrapper className={className}>
        <Label>{label}</Label>
        <Colon>:</Colon>
        {type == 'text' && <TextInput 
          id={label} 
          type="text" 
          onChange={this.onChange}
          value={this.state.value}
        />}
        {type == 'textarea' && <TextAreaInput 
          id={label} 
          onChange={this.onChange}
          value={this.state.value}
          rows={10}

        />}
      </Wrapper>
    );
  }

  onChange = event => {
    const value = event.target.value
    if (this.props.onChange) {
      this.props.onChange(event.target.value);
    }
    this.setState(state => ({...state, value }))
  };
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  align-items: center;
  margin-bottom: 10px;
  width: 100%;
`;
const Label = styled.label`
  width: 60px;
  flex: none;
`;
const Colon = styled.div`
  margin-left: auto;
  margin-right: 14px;
`;

const TextInput = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: none;
  border: 1px solid ${props => props.theme.panelBorder};
  border-radius: 3px;
`;

const TextAreaInput = styled.textarea`
  width: 100%;
  padding: 8px 12px;
  border: none;
  border: 1px solid ${props => props.theme.panelBorder};
  border-radius: 3px;
`;



// WEBPACK FOOTER //
// ./src/module-bulk-sms/tags/FieldRowWithTextInput.js